import type { CoachingQuotaLedger } from '@efdigital/ll-addon-data';
import { DataTypeCoaching } from '@efdigital/ll-addon-data/data-types/coaching';
import { jsonApiOptions } from '@efdigital/ll-admin-v2/lib/json-api';
import { query } from '@warp-drive/utilities/json-api';

export function queryQuotaLedgersForSession(coachingSessionId: string) {
  return query<CoachingQuotaLedger>(
    DataTypeCoaching.CoachingQuotaLedger,
    {
      'filter[coachingSession.id]': coachingSessionId,
    },
    jsonApiOptions
  );
}
